export default class URLParams {
    static getParams() {
        return new URLSearchParams(window.location.search);
    };
}